import { render } from "./DesignProcesses.vue?vue&type=template&id=7d44d8b9&scoped=true"
import script from "../js/design-processes.js?vue&type=script&lang=js"
export * from "../js/design-processes.js?vue&type=script&lang=js"

import "./DesignProcesses.vue?vue&type=style&index=0&id=7d44d8b9&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d44d8b9"]])

export default __exports__